import { render, staticRenderFns } from "./TableHistory.vue?vue&type=template&id=5b092da2&"
import script from "./TableHistory.vue?vue&type=script&lang=js&"
export * from "./TableHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports